import { SET_FEATURE_GATE } from '../types/featureGateConstants'

// ** Initial State
// All feature gates are stored in the 'flags' object
// null value means the flag hasn't been fetched yet
// boolean/string/number value means it has been fetched from API
const initialState = {
  flags: {} // { centrali3_0: null, canAccessMarketplace: null, etc. }
}

export default function featureGateReducer(state = initialState, action) {
  switch (action.type) {
    case SET_FEATURE_GATE:
      return {
        ...state,
        flags: {
          ...state.flags,
          [action.payload.flagName]: action.payload.value
        }
      }
    default:
      return state
  }
}
